/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '../../../../app/components/form/form-input-checkbox.component';
const styles_FormInputCheckboxComponent:any[] = ([] as any[]);
export const RenderType_FormInputCheckboxComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormInputCheckboxComponent,data:{}});
export function View_FormInputCheckboxComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),13,'label',[['class',
      'k-form-field']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),5,'input',[['class','k-checkbox'],['type','checkbox']],
          [[8,'id',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,5).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,5).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.CheckboxControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.CheckboxControlValueAccessor]),i0.ɵdid(540672,(null as any),0,i1.FormControlDirective,
          [[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],{form:[0,
              'form']},(null as any)),i0.ɵprd(2048,(null as any),i1.NgControl,(null as any),
          [i1.FormControlDirective]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n  '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'label',[['class',
          'k-checkbox-label']],[[8,'htmlFor',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),
          ['\n'])),(_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.FormInputCheckboxComponent = _v.component;
    const currVal_8:any = _co.F;
    _ck(_v,7,0,currVal_8);
  },(_ck,_v) => {
    var _co:i2.FormInputCheckboxComponent = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.id,'');
    const currVal_1:any = i0.ɵnov(_v,9).ngClassUntouched;
    const currVal_2:any = i0.ɵnov(_v,9).ngClassTouched;
    const currVal_3:any = i0.ɵnov(_v,9).ngClassPristine;
    const currVal_4:any = i0.ɵnov(_v,9).ngClassDirty;
    const currVal_5:any = i0.ɵnov(_v,9).ngClassValid;
    const currVal_6:any = i0.ɵnov(_v,9).ngClassInvalid;
    const currVal_7:any = i0.ɵnov(_v,9).ngClassPending;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = i0.ɵinlineInterpolate(1,'',_co.id,'');
    _ck(_v,11,0,currVal_9);
    const currVal_10:any = _co.LabelString;
    _ck(_v,12,0,currVal_10);
  });
}
export function View_FormInputCheckboxComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-form-input-checkbox',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormInputCheckboxComponent_0,
      RenderType_FormInputCheckboxComponent)),i0.ɵdid(49152,(null as any),0,i2.FormInputCheckboxComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FormInputCheckboxComponentNgFactory:i0.ComponentFactory<i2.FormInputCheckboxComponent> = i0.ɵccf('app-form-input-checkbox',
    i2.FormInputCheckboxComponent,View_FormInputCheckboxComponent_Host_0,{F:'F',ControlName:'ControlName',
        LabelString:'LabelString',id:'id'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZm9ybS9mb3JtLWlucHV0LWNoZWNrYm94LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jOi9Qcm9qZWN0cy9ZdURSSVYvU2VydmljZXNBUEkvWXVEcml2LVNlcnZpY2VzQVBJL0VuZm9yY2VtZW50L3NyYy9hcHAvY29tcG9uZW50cy9mb3JtL2Zvcm0taW5wdXQtY2hlY2tib3guY29tcG9uZW50LnRzIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZm9ybS9mb3JtLWlucHV0LWNoZWNrYm94LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZm9ybS9mb3JtLWlucHV0LWNoZWNrYm94LmNvbXBvbmVudC50cy5Gb3JtSW5wdXRDaGVja2JveENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxsYWJlbCBjbGFzcz1cImstZm9ybS1maWVsZFwiPlxyXG4gIDxiciAvPlxyXG4gIDxpbnB1dCBpZD1cInt7aWR9fVwiIHR5cGU9XCJjaGVja2JveFwiIGNsYXNzPVwiay1jaGVja2JveFwiIFtmb3JtQ29udHJvbF09XCJGXCI+XHJcbiAgPGxhYmVsIGZvcj1cInt7aWR9fVwiIGNsYXNzPVwiay1jaGVja2JveC1sYWJlbFwiPnt7IExhYmVsU3RyaW5nIH19PC9sYWJlbD5cclxuPC9sYWJlbD5cclxuIiwiPGFwcC1mb3JtLWlucHV0LWNoZWNrYm94PjwvYXBwLWZvcm0taW5wdXQtY2hlY2tib3g+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBNEIseUNBQzFCO1VBQUE7VUFBQSxnQkFBTSx5Q0FDTjtVQUFBO1VBQUE7Y0FBQTtrQkFBQTtVQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBLGlFQUFBOytCQUFBO1lBQUE7VUFBQSw0Q0FBQTtVQUFBO2NBQUEsK0JBQUE7VUFBQSxrQ0FBQTtVQUFBLDRDQUF3RTtVQUFBLFdBQ3hFO1VBQUE7VUFBQSxnQkFBNkMsd0NBQXlCO1VBQUEsU0FDaEU7O0lBRmdEO0lBQXRELFdBQXNELFNBQXREOzs7SUFBTztJQUFQO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBTyxVQUFQO1FBQUEsU0FBQTtJQUNPO0lBQVAsWUFBTyxTQUFQO0lBQTZDO0lBQUE7Ozs7b0JDSC9DO01BQUE7MkNBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/app/components/form/form-input-checkbox.component.ngfactory.ts